import React from 'react';
import { Card, Button } from '@ui-elements';
import { money } from 'common/utils/formatters';
import { Accessory } from '~/common/models';
import styles from './index.module.scss';
import ImgLazyLoad from '~/common/components/image-lazy-loading';

interface AccessoryCardProp extends Accessory {
  delay?: number;
  backgroundColor?: string;
}

export const AccessoryCard = React.memo<AccessoryCardProp>(
  ({ backgroundColor, ...prop }) => {
    const formatAccessoryName = (name: string) => {
      return name
        .replace(/[^a-zA-Z0-9\s]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .toLowerCase();
    };

    const truncateAccPackPath = (path) => {
      const index = path.indexOf('/accessories');
      return index !== -1 ? path.slice(0, index + '/accessories'.length) : path;
    };

    const constructAccBasePath = (path) => {
      const _path = truncateAccPackPath(path);
      return _path.endsWith('/accessories') || _path.endsWith('/accessories/')
        ? _path.replace(/\/+$/, '') // clean up any trailing slash
        : `${_path.replace(/\/+$/, '')}/accessories`;
    };

    const getURL = React.useCallback(() => {
      if (!!prop.accessoryCategoryName) {
        const formattedAccName = formatAccessoryName(prop.description);
        const formattedAccCategory = formatAccessoryName(
          prop.accessoryCategoryName
        );
        const cleanedPath = constructAccBasePath(window.location.pathname);
        return `${cleanedPath}/${formattedAccCategory}/${formattedAccName}`;
      }

      return '#';
    }, []);

    return (
      <div
        className={styles.accessory}
        style={{ animationDelay: `${prop.delay}ms` }}
      >
        <Card
          className={styles.accessoryCard}
          contentClassName={styles.accessoryCardContent}
        >
          <div className={styles.imageWrapper}>
            <ImgLazyLoad
              src={prop.imageSrc}
              alt={prop.description}
              loading="lazy"
            />
          </div>
          <div className={styles.detailsWrapper} style={{ backgroundColor }}>
            <div>
              <p className={styles.name}>{prop.description}</p>
              <p className={styles.price}>
                Fitted RRP: {money(prop.priceFitted)}
              </p>
            </div>
            <Button
              buttonSize="small"
              className={styles.moreInfoButton}
              href={getURL()}
            >
              More info
            </Button>
          </div>
        </Card>
      </div>
    );
  }
);
